import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const IntroductoryCallsWithSMCPlanByFellows = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Introductory calls with SMC plan by fellows" />
    </Box>
  );
};
